import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { PolizaCreditoListComponent } from './poliza-credito-list.component';

@Component({
    selector: 'convfact-poliza-credito-delete',
    templateUrl: './poliza-credito-dialog-delete.component.html',
    styleUrls: ['./poliza-credito.component.css'],
    standalone: false
})
export class PolizaCreditoDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<PolizaCreditoListComponent>,
    public polizaCreditoService: PolizaCreditoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.polizaCreditoService.delete(this.uid)
      .then(res => {
        this.response_message = "La póliza se ha eliminado correctamente";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar la póliza";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
